/**
 * Gestión de las ascensiones
 *
 * @link https://www.mendikat.net
 * @author Javi Urrutia <javi@mendikat.net>
 * @copyright 2023-2026 Mendikat
 * @license Mendikat
 *
 */

const { default: Axios } = require('axios');

const Climbs =
    {
        data :
            {
                // La montaña de referencia para las ascensiones
                climbed_mountain :  null,

                // La lista de ascensiones
                climbed_climbs   : [],

                // Si las ascensiones han sido guardadas o no
                climbed_saved     : false,
            },
        methods : {
            /**
             * Abre la modal de gestión de las ascensiones
             *
             * @param {Mountain} mountain   La montaña
             *
             */
            openClimbsModal : function (mountain) {

                // Carga la montaña a tratar
                this.climbed_mountain = mountain;

                this.climbed_mountain.climbed = true;

                // Carga la montaña y sus ascensiones
                this.loadMountainClimbs();

                // Abrir la modal con las ascensiones
                this.$bvModal.show('modal-edit-climbs');
            },
            /**
             * Carga las ascensiones del usuario a la montaña
             *
             */
            loadMountainClimbs: function () {

                // Carga las ascensiones del usuario a la montaña
                Axios.post(`/com/climb/get/${this.climbed_mountain.id}`)
                    .then(response => {
                        // Fija las ascensiones
                        this.climbed_climbs = response.data;

                        // Si no hay ascensiones, se añade una nueva
                        if (this.climbed_climbs.length == 0) {
                            this.addClimb();
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    });
            },
            /**
             * Elimina una ascensión
             *
             * @param {Climb} climb     La ascensión a eliminar
             *
             */
            deleteClimb: function (climb) {
                // Elimina la ascensión seleccionada
                this.climbed_climbs = this.climbed_climbs.filter(_climb => _climb != climb);
            },
            /**
             * Añade una nueva ascensión
             *
             */
            addClimb: function () {
                // Añade una nueva ascensión a la lista de ascensiones (en primer lugar)
                this.climbed_climbs.unshift(
                    {
                        id          : null,
                        date        : new Date().toISOString(),
                        text        : null,
                        mountain_id : this.climbed_mountain.id,
                        user_id     : this.user.id,
                    }
                );
            },
            /**
             * Guarda las ascensiones
             *
             */
            saveClimbs: function () {
                // Guarda las ascensiones del usuario a la montaña
                Axios.post(`/com/climb/save/${this.climbed_mountain.id}`,
                    {
                        climbs : this.climbed_climbs,
                    }
                )
                .then(response => {
                    // Las ascensiones han sido guardadas
                    this.climbed_saved = true;

                    // Muestra la modal indicando que las ascensiones han sido guardadas
                    this.$bvModal.hide('modal-edit-climbs');
                    this.$bvModal.show('modal-climbs-saved-success');
                })
                .catch(error => {
                    console.error(error);
                });
            },
        },
    };

module.exports = Climbs;
